import { useEffect } from 'react';
import useModalState from '@sdk/components/ui/modal/useModalState';
import getCurrentBreak from '@sdk/automatedBreaks/helpers/getCurrentBreak';
import getBreaksSummary from '@sdk/automatedBreaks/helpers/getBreaksSummary';
import { ngettext } from '@sdk/lang/gettext';

import { Props } from '@web/timeClock/BackTooSoonModal/backTooSoonModal.types';

export const useBackTooSoonModal = ({ shift, shouldShow, onClose }: Props) => {
  const { isVisible, open, close } = useModalState();

  useEffect(() => {
    if (shouldShow && !isVisible) {
      open();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShow]);

  const handleClose = async () => {
    close();
    onClose();
  };

  const getBreakDurationMessage = () => {
    const { timesheetEntries, dtstart, dtend } = shift;
    const { breakRecords } = getBreaksSummary(timesheetEntries, dtstart, dtend);
    const currentBreak = getCurrentBreak(breakRecords);
    const breakDuration = currentBreak ? currentBreak.settings.duration : 0;

    return ngettext(
      'Your break is scheduled to last %(breakDuration)s minute.',
      'Your break is scheduled to last %(breakDuration)s minutes.',
      breakDuration,
      { breakDuration }
    );
  };

  return { isVisible, handleClose, getBreakDurationMessage };
};
